/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyRefundPayment from './pharmacy-refund-payment';
import PharmacyRefundPaymentDetail from './pharmacy-refund-payment-detail';
import PharmacyRefundPaymentUpdate from './pharmacy-refund-payment-update';
import PharmacyRefundPaymentDeleteDialog from './pharmacy-refund-payment-delete-dialog';

const PharmacyRefundPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyRefundPayment />} />
    <Route path="new" element={<PharmacyRefundPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyRefundPaymentDetail />} />
      <Route path="edit" element={<PharmacyRefundPaymentUpdate />} />
      <Route path="delete" element={<PharmacyRefundPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyRefundPaymentRoutes;
